import { render, staticRenderFns } from "./ReportArFieldCollection.vue?vue&type=template&id=45ece9d2&scoped=true"
import script from "./ReportArFieldCollection.vue?vue&type=script&lang=js"
export * from "./ReportArFieldCollection.vue?vue&type=script&lang=js"
import style0 from "./ReportArFieldCollection.vue?vue&type=style&index=0&id=45ece9d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ece9d2",
  null
  
)

export default component.exports